import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserTreeResponse, AdminUserTreeResponse, ENVIRONMENT } from 'shared';

export interface UserTreeFilters {
  page?: number;
  per_page?: number;
  sort_column?: string;
  sort_direction?: 'asc' | 'desc';
}

@Injectable({
  providedIn: 'root'
})
export class UserTreeService {
  private readonly apiUrl = this.environment.apiUrl || 'http://localhost:3000/api';

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: any
  ) {}

  /**
   * Get user tree for a specific user or current user
   * @param userId - User ID or 'me' for current user
   * @param filters - Pagination and sorting filters
   */
  getUserTree(userId: number | 'me', filters?: UserTreeFilters): Observable<UserTreeResponse> {
    let params = new HttpParams();

    if (filters) {
      if (filters.page) {
        params = params.set('page', filters.page.toString());
      }
      if (filters.per_page) {
        params = params.set('per_page', filters.per_page.toString());
      }
      if (filters.sort_column) {
        params = params.set('sort_column', filters.sort_column);
      }
      if (filters.sort_direction) {
        params = params.set('sort_direction', filters.sort_direction);
      }
    }

    return this.http.get<UserTreeResponse>(`${this.apiUrl}/user_tree/${userId}`, { params });
  }

  /**
   * Get admin user tree starting from root users (users without sponsor)
   * Includes user details: first_name, last_name, email
   * Admin only
   * @param userId - User ID or 'root' for root users
   * @param filters - Pagination and sorting filters
   */
  getAdminUserTree(userId: number | 'root', filters?: UserTreeFilters): Observable<AdminUserTreeResponse> {
    let params = new HttpParams();

    if (filters) {
      if (filters.page) {
        params = params.set('page', filters.page.toString());
      }
      if (filters.per_page) {
        params = params.set('per_page', filters.per_page.toString());
      }
      if (filters.sort_column) {
        params = params.set('sort_column', filters.sort_column);
      }
      if (filters.sort_direction) {
        params = params.set('sort_direction', filters.sort_direction);
      }
    }

    return this.http.get<AdminUserTreeResponse>(`${this.apiUrl}/admin/user_tree/${userId}`, { params });
  }
}
